const globalInit: (() => void)[] = [];
export function init(func: () => void) {
  globalInit.push(func);
}

export function runGlobalInit() {
  globalInit.forEach(x => x());
}
